define.alias("shared/components/shared/social/facebook-modal/facebook-page", "calendar/components/shared/social/facebook-modal/facebook-page");